const albums = {
  album01: require('./01.png').default,
  album02: require('./02.jpeg').default,
  album03: require('./03.jpg').default,
  album04: require('./04.jpg').default,
  album05: require('./05.jpg').default,
  album06: require('./06.jpg').default,
  album07: require('./07.jpg').default,
  album08: require('./08.jpg').default,
  album09: require('./09.jpg').default,
  album10: require('./10.jpg').default
}

export default albums;